import { AbstractControl } from '@angular/forms';

export class ControlPlateUtils {
  private static readonly controlPlateRegex = /^[A-ZÄÖÜ0-9-]+$/;

  public static normalizeControlPlateValue(value: string | null | undefined): string | null {
    if (value === null || value === undefined) {
      return value ?? null;
    }

    return value.replace(/\s+/g, '-').toUpperCase().substring(0, 50);
  }

  public static isControlPlateValid(value: string | null | undefined): boolean {
    const normalizedValue = ControlPlateUtils.normalizeControlPlateValue(value ?? '');
    if (!normalizedValue) {
      return true;
    }

    return ControlPlateUtils.controlPlateRegex.test(normalizedValue);
  }

  public static setupControlPlateNormalization(control: AbstractControl | null | undefined): void {
    if (!control) {
      return;
    }

    const normalizeValue = (value: string | null | undefined) =>
      ControlPlateUtils.normalizeControlPlateValue(value);

    control.valueChanges.subscribe((value: string | null | undefined) => {
      const normalizedValue = normalizeValue(value);
      if (normalizedValue !== value) {
        control.setValue(normalizedValue, { emitEvent: false });
      }
    });
  }
}
